import {Suspense, lazy} from 'react'
import {Redirect, Route, Switch} from 'react-router-dom'
import {FallbackView} from '../../_eLab/partials'
import {DashboardWrapper} from '../pages/dashboard/DashboardWrapper'
import {MenuTestPage} from '../pages/MenuTestPage'

export function PrivateRoutes() {
  const BuilderPageWrapper = lazy(() => import('../pages/layout-builder/BuilderPageWrapper'))
  const ProfilePage = lazy(() => import('../modules/profile/ProfilePage'))
  const WizardsPage = lazy(() => import('../modules/wizards/WizardsPage'))
  const AccountPage = lazy(() => import('../modules/accounts/AccountPage'))
  const WidgetsPage = lazy(() => import('../modules/widgets/WidgetsPage'))
  const ChatPage = lazy(() => import('../modules/apps/chat/ChatPage'))
  // ============================ Master ========================
  const CountryMasterPage = lazy(
    () => import('../modules/master-page/country-master-page/CountryMasterPage')
  )
  // ================================================================
  const StateMasterPage = lazy(
    () => import('../modules/master-page/state-master-page/StateMasterPage')
  )
  // ================================================================
  const CityMasterPageMasterPage = lazy(
    () => import('../modules/master-page/district-master-page/CityMasterPageMasterPage')
  )
  // ================================================================
  const TalukaMasterPage = lazy(
    () => import('../modules/master-page/taluka-master-page/TalukaMasterPage')
  )
  // ================================================================
  const NationalityMasterPage = lazy(
    () => import('../modules/master-page/nationality-master-page/NationalityMasterPage')
  )
  // ================================================================
  const EducationCategoryPage = lazy(
    () => import('../modules/master-page/education-category-master-page/EducationCategoryPage')
  )
  // ================================================================
  const EducationDepartmentPage = lazy(
    () => import('../modules/master-page/education-department-master-page/EducationDepartmentPage')
  )
  // ================================================================
  const DocumentTypePage = lazy(
    () => import('../modules/master-page/document-type-page/DocumentTypePage')
  )
  // ================================================================
  const KycDocumentMasterPage = lazy(
    () => import('../modules/master-page/kyc-document-page/KycDocumentMasterPage')
  )
  // ================================================================
  const DoctorDesignationMasterPage = lazy(
    () => import('../modules/master-page/doctor-degree-master-page/DoctorDegreeMasterPage')
  )
  // ================================= Organization ==========================
  const EmployeeMasterPage = lazy(
    () => import('../modules/organization-page/employee-master-page/EmployeeMasterPage')
  )
  // ================================================================
  const UserMasterPage = lazy(
    () => import('../modules/organization-page/user-master-page/UserMasterPage')
  )
  // ================================================================
  const CustomerMasterPage = lazy(
    () => import('../modules/organization-page/customer-master-page/CustomerMasterPage')
  )
  // ================================================================
  const DepartmentMasterPage = lazy(
    () => import('../modules/master-page/department-master-page/DepartmentMasterPage')
  )
  // ================================================================
  const DesignationMasterPage = lazy(
    () => import('../modules/master-page/designation-master-page/DesignationMasterPage')
  )
  // ================================================================
  const BranchMasterPage = lazy(
    () => import('../modules/master-page/branch-master-page/BranchMasterPage')
  )
  // ================================================================
  const OrganizationBankMasterPage = lazy(
    () => import('../modules/master-page/organization-bank-master-page/OrganizationBankMasterPage')
  )
  // ================================================================
  // const ChangePasswordPage = lazy(() => import('../modules/change-password/ChangePasswordPage'))

  // ================================================================
  const AreaPinCodeMasterPage = lazy(
    () => import('../modules/master-page/area-pincode-master-page/AreaPinCodeMasterPage')
  )

  // ================================================================
  const SocietyMasterPage = lazy(
    () => import('../modules/master-page/society-master-page/SocietyMasterPage')
  )
  // ========================================================================================
  const ServiceCategoryMasterPage = lazy(
    () => import('../modules/master-page/service-category-master-page/ServiceCategoryMasterPage')
  )
  // ========================================================================================
  const ServiceSubCategoryMasterPage = lazy(
    () =>
      import('../modules/master-page/service-subcategory-master-page/ServiceSubCategoryMasterPage')
  )
  // ========================================================================================
  const LaundryTypeMasterPage = lazy(
    () => import('../modules/master-page/laundry-type-master-page/LaundryTypeMasterPage')
  )

  // ========================================================================================
  const ItemCategoryMaterPage = lazy(
    () => import('../modules/master-page/item-category-master-page/ItemCategoryMaterPage')
  )

  // ========================================================================================
  const ItemMaterPage = lazy(() => import('../modules/master-page/item-master-page/ItemMasterPage'))

  // ====================================driver tip====================================================
  const DriverTipMaterPage = lazy(
    () => import('../modules/master-page/driver-tip-master-page/DriverTipMasterPage')
  )
  // ========================================================================================
  const PickupDropPointMasterPage = lazy(
    () => import('../modules/master-page/pickup-drop-point-master-page/PickupDropPointMasterPage')
  )
  // ========================================================================================
  const ServiceCentreMastrePage = lazy(
    () => import('../modules/master-page/service-center/ServiceCentreMastrePage')
  )
  // =======================================================================
  const OfferMasterPage = lazy(
    () => import('../modules/master-page/offer-master-page/OfferMasterPage')
  )
  // =======================================================================
  const CouponMasterPage = lazy(
    () => import('../modules/master-page/coupon-master-page/CouponMasterPage')
  )

  // ============================================================================
  const PickupScheduleMasterPage = lazy(
    () => import('../modules/lab-test-manage/pickup_schedule-master-page/PickupScheduleMasterPage')
  )
  // ============================================================================
  const DeliveryScheduleMasterPage = lazy(
    () => import('../modules/schedules-mst-pages/DeliveryScheduleMasterPage')
  )
  // ============================================================================
  const BannerImageMasterPage = lazy(
    () => import('../modules/master-page/banner-image-master-page/BannerImageMasterPage')
  )
  // ============================================================================
  const HomeVideoMasterPage = lazy(
    () => import('../modules/master-page/home-video-master-page/HomeVideoMasterPage')
  )
  // ============================================================================
  const ConfigurationMasterPage = lazy(
    () => import('../modules/configuration-master-page/ConfigurationMasterPage')
  )
  // ============================================================================

  // ===================================orders=========================================
  const OpenOrderMasterPage = lazy(() => import('../modules/orders/open-order/OpenOrderMasterPage'))
  const CloseOrderMasterPage = lazy(
    () => import('../modules/orders/close-order/CloseOrderMasterPage')
  )
  const MismatchOrderMasterPage = lazy(
    () => import('../modules/orders/mismatch-order/MismatchOrderMasterPage')
  )
  const CriticalOrderMasterPage = lazy(
    () => import('../modules/orders/critical-order/CriticalOrderMasterPage')
  )
  const TipManageMasterPage = lazy(() => import('../modules/orders/tip-manage/TipManageMasterPage'))
  const FeedBackMasterPage = lazy(() => import('../modules/orders/feed-back/FeedBackMasterPage'))
  const OrderReportMasterPage = lazy(
    () => import('../modules/orders/reports/OrderReportMasterPage')
  )
  const GSTReportMasterPage = lazy(
    () => import('../modules/gst-reports-master-page/GSTReportMasterPage')
  )
  const DayWisePaymentReportsMasterPage = lazy(
    () => import('../modules/payment-reports/DayWisePaymentReportsMasterPage')
  )
  const MonthWisePaymentReportsMasterPage = lazy(
    () => import('../modules/payment-reports/MonthWisePaymentReportsMasterPage')
  )
  // =========================================
  const OfflineOrderMasterPage = lazy(
    () => import('../modules/orders/offline-order/OfflineOrderMasterPage')
  )
  // ===================lab test manage==========================

  const CollectionMasterPage = lazy(
    () => import('../modules/lab-test-manage/collection-master-page/CollectionMasterPage')
  )
  const ParameterUnitMasterPage = lazy(
    () => import('../modules/lab-test-manage/parameterUnit-master-page/ParameterUnitMasterPage')
  )
  const TestParameterMasterPage = lazy(
    () => import('../modules/lab-test-manage/test-parameter-master-page/TestParameterMasterPage')
  )
  const TestInstructionMasterpage = lazy(
    () =>
      import('../modules/lab-test-manage/test-instruction-master-page/TestInstructionMasterpage')
  )
  const PreRequiredMasterPage = lazy(
    () => import('../modules/lab-test-manage/pre-required/PreRequiredMasterPage')
  )
  const TestCategoryMasterPage = lazy(
    () => import('../modules/lab-test-manage/test-category-master-page/TestCategoryMasterPage')
  )
  const TestMasterPage = lazy(
    () => import('../modules/lab-test-manage/test-master-page/TestMasterPage')
  )
  const TestTypeMasterPage = lazy(
    () => import('../modules/lab-test-manage/test-type-page/TestTypeMasterPage')
  )
  const SpecialistMasterPage = lazy(
    () => import('../modules/lab-test-manage/specialist-master-page/SpecialistMasterPage')
  )

  // ====================================Lab master=================================
  const LabMasterPage = lazy(() => import('../modules/lab-master-page/LabMasterPage'))
  // ====================================doctor =================================
  const DoctorMasterPage = lazy(() => import('../modules/doctor-master-page/DoctorMasterPage'))
  // ====================================doctor patient =================================
  const DoctorPatientMasterPage = lazy(
    () => import('../modules/doctor-patient-master-page/DoctorPatientMasterPage')
  )
  // ====================================prescripton =================================
  const PrescriptionMasterPage = lazy(
    () => import('../modules/prescription-master-page/PrescriptionMasterPage')
  )
  // ====================================Order =================================
  const TestLabMasterPage = lazy(
    () => import('../modules/order-page/test-lab-master-page/TestLabMasterPage')
  )
  const RediologyHomeMasterPage = lazy(
    () => import('../modules/order-page/redilogy-home-master-page/RediologyHomeMasterPage')
  )
  const RediologyLabMasterPage = lazy(
    () => import('../modules/order-page/redilogy-lab-master-page/RediologyLabMasterPage')
  )
  const HealthCareMasterPage = lazy(
    () => import('../modules/order-page/healthcare-master-page/HealthCareMasterPage')
  )
  // --------------------- Order Mangement ---------------------
  const CustomerTestLabMasterPage = lazy(
    () => import('../modules/OrderManagement/ByCustomer/CustomerTestLabMasterPage')
  )

  const CustomerRediologyHomeMasterPage = lazy(
    () => import('../modules/OrderManagement/ByCustomer/CustomerRediologyHomeMasterPage')
  )

  const CustomerRediologyLabMasterPage = lazy(
    () => import('../modules/OrderManagement/ByCustomer/CustomerRediologyLabMasterPage')
  )

  const CustomerHealthCareMasterPage = lazy(
    () => import('../modules/OrderManagement/ByCustomer/CustomerHealthCareMasterPage')
  )

  const DoctorTestLabMasterPage = lazy(
    () => import('../modules/OrderManagement/ByDoctor/DoctorTestLabMasterPage')
  )
  const DoctorRediologyHomeMasterPage = lazy(
    () => import('../modules/OrderManagement/ByDoctor/DoctorRediologyHomeMasterPage')
  )
  const DoctorRediologyLabMasterPage = lazy(
    () => import('../modules/OrderManagement/ByDoctor/DoctorRediologyLabMasterPage')
  )
  const LabPaymentMasterPage = lazy(() => import('../modules/payment/LabPaymentMasterPage'))
  const DoctorPaymentMasterPage = lazy(() => import('../modules/payment/DoctorPaymentMasterPage'))
  const WithdrawRequestMasterPage = lazy(
    () => import('../modules/withdraw-request/WithdrawRequestMasterPage')
  )

  return (
    <Suspense fallback={<FallbackView />}>
      <Switch>
        <Route path='/dashboard' component={DashboardWrapper} />
        <Route path='/builder' component={BuilderPageWrapper} />
        <Route path='/crafted/pages/profile' component={ProfilePage} />
        <Route path='/crafted/pages/wizards' component={WizardsPage} />
        <Route path='/crafted/widgets' component={WidgetsPage} />
        <Route path='/crafted/account' component={AccountPage} />
        <Route path='/apps/chat' component={ChatPage} />
        <Route path='/menu-test' component={MenuTestPage} />
        <Route path='/locations/country' component={CountryMasterPage} />
        <Route path='/locations/taluka' component={TalukaMasterPage} />
        <Route path='/master/nationality' component={NationalityMasterPage} />
        <Route path='/master/eduDepartment' component={EducationDepartmentPage} />
        <Route path='/master/eduCategory' component={EducationCategoryPage} />
        <Route path='/master/documenttype' component={DocumentTypePage} />
        <Route path='/master/kycdocument' component={KycDocumentMasterPage} />
        <Route path='/master/bannerimage' component={BannerImageMasterPage} />
        <Route path='/master/homevideo' component={HomeVideoMasterPage} />
        <Route path='/organization/employee' component={EmployeeMasterPage} />
        <Route path='/organization/user' component={UserMasterPage} />
        <Route path='/organization/customer' component={CustomerMasterPage} />
        <Route path='/master/department' component={DepartmentMasterPage} />
        <Route path='/master/designation' component={DesignationMasterPage} />
        <Route path='/master/branch' component={BranchMasterPage} />
        <Route path='/master/bank' component={OrganizationBankMasterPage} />
        <Route path='/master/service-subcategory' component={ServiceSubCategoryMasterPage} />
        <Route path='/master/laundry-type' component={LaundryTypeMasterPage} />
        <Route path='/master/doctor-degree' component={DoctorDesignationMasterPage} />
        <Route path='/master/offer' component={OfferMasterPage} />
        <Route path='/master/coupon' component={CouponMasterPage} />

        {/* ==================== Product Manage ============== */}
        <Route path='/product-manage/service-category' component={ServiceCategoryMasterPage} />
        <Route path='/product-manage/item-category' component={ItemCategoryMaterPage} />
        <Route path='/product-manage/items' component={ItemMaterPage} />
        <Route path='/product-manage/driver-tip' component={DriverTipMaterPage} />

        {/* ==================== Locations ============== */}
        <Route path='/locations/state' component={StateMasterPage} />
        <Route path='/locations/city' component={CityMasterPageMasterPage} />
        <Route path='/locations/areapincode' component={AreaPinCodeMasterPage} />
        <Route path='/locations/society' component={SocietyMasterPage} />
        <Route path='/locations/pickup-drop-point' component={PickupDropPointMasterPage} />
        <Route path='/locations/service-center' component={ServiceCentreMastrePage} />

        {/* //=============== Schedules ============= */}

        <Route path='/schedules/delivery-schedule' component={DeliveryScheduleMasterPage} />
        {/* //=============== Configuration ============= */}
        <Route path='/configuration' component={ConfigurationMasterPage} />

        {/* //=============== Configuration ============= */}
        <Route path='/offer' component={OfferMasterPage} />

        {/* //=============== Reports ============= */}
        <Route path='/gst-report' component={GSTReportMasterPage} />
        <Route
          path='/payment-reports/daywise-payment-report'
          component={DayWisePaymentReportsMasterPage}
        />
        <Route
          path='/payment-reports/monthwise-payment-report'
          component={MonthWisePaymentReportsMasterPage}
        />
        {/* //=============== orders ============= */}
        <Route path='/orders/open-order' component={OpenOrderMasterPage} />
        <Route path='/orders/offline-order' component={OfflineOrderMasterPage} />
        <Route path='/orders/close-order' component={CloseOrderMasterPage} />
        <Route path='/orders/mismatch-order' component={MismatchOrderMasterPage} />
        <Route path='/orders/critical-order' component={CriticalOrderMasterPage} />
        <Route path='/orders/tip-manage' component={TipManageMasterPage} />
        <Route path='/orders/feedback' component={FeedBackMasterPage} />
        <Route path='/orders/reports' component={OrderReportMasterPage} />

        {/* ======================lab test manage============================= */}
        <Route path='/labtestmng/colllection' component={CollectionMasterPage} />
        <Route path='/labtestmng/parameter-unit' component={ParameterUnitMasterPage} />
        <Route path='/labtestmng/test-parameter' component={TestParameterMasterPage} />
        <Route path='/labtestmng/test-instruction' component={TestInstructionMasterpage} />
        <Route path='/labtestmng/prerequired' component={PreRequiredMasterPage} />
        <Route path='/labtestmng/test-type' component={TestTypeMasterPage} />
        {/* <Route path='/labtestmng/pickup-schedule' component={OpenOrderMasterPage} /> */}
        <Route path='/labtestmng/test-category' component={TestCategoryMasterPage} />
        <Route path='/labtestmng/tests' component={TestMasterPage} />
        <Route path='/labtestmng/pickup-schedule' component={PickupScheduleMasterPage} />
        <Route path='/labtestmng/speciality' component={SpecialistMasterPage} />
        {/* ==================================Lab Master============================ */}
        <Route path='/lab' component={LabMasterPage} />
        {/* ==================================Doctor ============================ */}
        <Route path='/doctors' component={DoctorMasterPage} />
        {/* ==================================Doctor patient ============================ */}
        <Route path='/doctor-patient' component={DoctorPatientMasterPage} />
        {/* ==================================Prescription ============================ */}
        <Route path='/prescription' component={PrescriptionMasterPage} />
        {/* ==================================Order ============================ */}
        <Route path='/order/test-lab' component={TestLabMasterPage} />
        <Route path='/order/redilogys' component={RediologyHomeMasterPage} />
        <Route path='/order/redilogy-lab' component={RediologyLabMasterPage} />
        <Route path='/order/healthcare' component={HealthCareMasterPage} />
        {/* ----------------------- Order Management ---------------------- */}
        <Route
          path='/order-management/by-customer/test-lab'
          component={CustomerTestLabMasterPage}
        />
        <Route
          path='/order-management/by-customer/redilogys-home'
          component={CustomerRediologyHomeMasterPage}
        />
        <Route
          path='/order-management/by-customer/redilogy-lab'
          component={CustomerRediologyLabMasterPage}
        />
        <Route
          path='/order-management/by-customer/health-care'
          component={CustomerHealthCareMasterPage}
        />
        <Route path='/order-management/by-doctor/test-lab' component={DoctorTestLabMasterPage} />
        <Route
          path='/order-management/by-doctor/redilogys-home'
          component={DoctorRediologyHomeMasterPage}
        />
        <Route
          path='/order-management/by-doctor/redilogy-lab'
          component={DoctorRediologyLabMasterPage}
        />
        <Route path='/payment/lab-payment-report' component={LabPaymentMasterPage} />
        <Route path='/payment/doctor-payment-report' component={DoctorPaymentMasterPage} />
        <Route path='/withdraw-request' component={WithdrawRequestMasterPage} />
        <Redirect from='/' to='/dashboard' />
        <Redirect exact from='/' to='/dashboard' />
        <Redirect to='error/404' />
      </Switch>
    </Suspense>
  )
}
